<template>
  <div>
    <a-textarea
      v-if="config.type === 'textarea'"
      :disabled="disabled"
      :placeholder="config.placeholder || `请输入${config.label}`"
      :value="field.value"
      :maxlength="config.maxlength"
      :show-count="!!config.maxlength"
      allow-clear
      @change="handleChange"
      @blur="onBlur"
    />
    <a-input
      v-else
      allow-clear
      :placeholder="config.placeholder || `请输入${config.label}`"
      :disabled="disabled"
      :value="field.value"
      :type="config.type || 'textarea'"
      :maxlength="config.maxlength"
      :show-count="!!config.maxlength"
      @change="handleChange"
      @blur="onBlur"
    />
  </div>
</template>
<script>
import { props } from './helper';
import { defineComponent, nextTick } from 'vue';

export default defineComponent({
  props,
  emits: ['component-event', 'input'],
  setup(props, { emit }) {
    const onBlur = () => {
      nextTick(() => {
        emit('component-event', {
          name: 'input-blur',
          item: props.field,
          config: props.config,
        });
      });
    };
    return { onBlur };
  },
});
</script>
<style lang="less" scoped></style>
